import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testid="page-terms"
      eyebrow="Terms"
      title="Terms of Service."
      lastUpdated="May 2026"
    >
      <p>
        These Terms govern your use of InstaVibe at <a href="https://instavibe.co.uk/" className="text-cyan hover:text-klein">instavibe.co.uk</a>. By creating an account you agree to them. If you do not agree, please do not use the service.
      </p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">1. What InstaVibe does</h2>
      <p>InstaVibe is an Instagram DM automation service built on the official Meta Graph API. We let you define keyword triggers and send automated replies on your behalf to direct messages and post comments received on your connected Instagram business account.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">2. Eligibility</h2>
      <p>You must be at least 18 years old and the lawful owner of the Instagram business account you connect. You are responsible for complying with the <a href="https://help.instagram.com/581066165581870" target="_blank" rel="noopener noreferrer" className="text-cyan hover:text-klein">Instagram Community Guidelines</a> and Meta's Platform Terms.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">3. Subscription &amp; billing</h2>
      <p>InstaVibe is offered as a recurring subscription. Current pricing: <strong className="text-white">Starter $9.99/month or $99/year</strong>; <strong className="text-white">Pro $29.99/month or $299/year</strong>. Subscriptions renew automatically until cancelled. You can cancel any time from the Billing page; access continues until the end of the current billing period.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">4. Free trial</h2>
      <p>New users may be offered a 14-day free trial. We do not require a credit card to start the trial. Trial features may be limited at our discretion.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">5. Acceptable use</h2>
      <p>You may not use InstaVibe to send spam, harass anyone, distribute malware, violate any law, or breach Meta's Platform Terms. We reserve the right to suspend or terminate accounts that abuse the service.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">6. Service availability</h2>
      <p>We work hard to keep InstaVibe online. We do not guarantee uninterrupted availability — Meta's webhook delivery, Stripe's payment infrastructure, and our hosting provider are dependencies outside our direct control.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">7. Liability</h2>
      <p>To the maximum extent permitted by law, InstaVibe is provided "as is". Our total liability for any claim is limited to the amount you paid us in the 12 months before the claim arose.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">8. Changes</h2>
      <p>We may update these Terms. Material changes will be announced via email or an in-app notice at least 14 days before they take effect.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">9. Governing law</h2>
      <p>These Terms are governed by the laws of Scotland, United Kingdom. Disputes are subject to the exclusive jurisdiction of the courts of Scotland.</p>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">10. Contact</h2>
      <p>Questions? Email <a href="mailto:hello@instavibe.co.uk" className="text-cyan hover:text-klein">hello@instavibe.co.uk</a>.</p>
    </LegalLayout>
  );
}
